import isUndefined from 'lodash/isUndefined';
import omitBy from 'lodash/omitBy';

import { buildSpousalData } from 'util/spousal/spousalAnalytics';

import { backendAnalyticsTrack, frontendAnalyticsTrack } from '../utils';
import {
  COMPLETED_HEALTH_NAVIGATOR_EVENT,
  COMPLETED_HEALTH_NAVIGATOR_BACKEND_ACTION,
  COMPLETED_NAVIGATOR_STEP_EVENT,
  STARTED_HEALTH_NAVIGATOR_BACKEND_ACTION,
  STARTED_HEALTH_NAVIGATOR_EVENT,
  SELECTED_OPTION_EVENT,
  STARTED_NAVIGATOR_STEP_EVENT,
  StepName,
  COLLECTED_CONTACT_INFO_EVENT,
  SKIPPED_REFERRAL_OFFBOARD_EVENT,
} from './constants';

export const startedNavigatorStep = (
  step: StepName,
  activeUserUuid: string,
  extras?: Record<string, unknown>
) => {
  frontendAnalyticsTrack(STARTED_NAVIGATOR_STEP_EVENT, {
    ...buildSpousalData(activeUserUuid),
    step,
    ...extras,
  });
};

export const completedNavigatorStep = (
  step: StepName,
  activeUserUuid: string,
  extras?: Record<string, unknown>
) => {
  frontendAnalyticsTrack(COMPLETED_NAVIGATOR_STEP_EVENT, {
    ...buildSpousalData(activeUserUuid),
    step,
    ...extras,
  });
};

export const startedHealthNavigator = (activeUserUuid: string) => {
  frontendAnalyticsTrack(STARTED_HEALTH_NAVIGATOR_EVENT, {
    ...buildSpousalData(activeUserUuid),
  });

  backendAnalyticsTrack({ action: STARTED_HEALTH_NAVIGATOR_BACKEND_ACTION });
};

export const completedHealthNavigator = (activeUserUuid: string) => {
  frontendAnalyticsTrack(COMPLETED_HEALTH_NAVIGATOR_EVENT, {
    section: 'Health',
    ...buildSpousalData(activeUserUuid),
  });

  backendAnalyticsTrack({ action: COMPLETED_HEALTH_NAVIGATOR_BACKEND_ACTION });
};

export const trackSelectedOption = (
  optionValue: string | string[] | Record<string, any>,
  step: StepName
) => {
  frontendAnalyticsTrack(SELECTED_OPTION_EVENT, {
    [typeof optionValue == 'string' ? 'option' : 'options']: optionValue,
    step,
  });
};

type ContactInfoOptions = Record<'email' | 'phone', boolean>;
export const trackCollectedContactInfo = (source: string, options: Partial<ContactInfoOptions>) => {
  frontendAnalyticsTrack(COLLECTED_CONTACT_INFO_EVENT, {
    source,
    ...omitBy(options, isUndefined),
  });
};
export const trackSkippedPartnerReferralOffboard = (
  step: StepName,
  data: Record<string, unknown>
) => {
  frontendAnalyticsTrack(SKIPPED_REFERRAL_OFFBOARD_EVENT, { step, data });
};
